// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  border-collapse: separate;
  border-spacing: 0;
}

th.mat-header-cell,
td.mat-cell {
  padding: 0 16px !important;
  white-space: nowrap;
}

tr.mat-row:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

tr.mat-row {
  height: 52px;
}

tr.mat-header-row {
  height: 52px;
  background-color: #fafafa;
}

.deactivated-row td {
  color: #aaa !important;
  background-color: #f5f5f5 !important;
  opacity: 0.7;
}

.deactivated-row:hover td {
  background-color: #eeeeee !important;
}

.selection-bar {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 0 16px;
  border-radius: 8px;
  margin: 10px 0;
  width: 100%;
  min-height: 48px;
}

.selection-info {
  display: flex;
  align-items: center;
}

.vertical-divider {
  width: 1px;
  height: 24px;
  background-color: #dbdbdb;
  margin: 0 12px;
}

.selection-count {
  font-weight: 500;
  color: #1c1c1c;
  font-size: 14px;
  font-weight: 400;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.filter-row mat-form-field {
  width: 250px;
}

.btn {
  background: linear-gradient(90deg, #00b2ff 0%, #1288ff 100%) !important;
  color: white !important;
  border-radius: 24px !important;
  font-size: 14px;
  font-weight: 600;
}

.ml-auto {
  margin-left: auto !important;
}

.download-btn {
  background-color: transparent !important;
  color: #1288ff !important;
  border: 1px solid #1288ff !important;
  border-radius: 24px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  cursor: pointer;
}

.white-spinner ::ng-deep circle {
  stroke: #999999 !important;
}

.filter-row mat-form-field {
  width: 250px;
}

:host ::ng-deep .filter-row .mat-form-field-wrapper {
  padding: 0 !important;
  margin: 0 !important;
}

:host ::ng-deep .filter-row .mat-form-field-subscript-wrapper {
  display: none !important;
}

:host ::ng-deep .filter-row .mat-form-field-infix {
  padding: 8px 0 !important;
  border-top: 0 !important;
  width: auto !important;
}

:host
  ::ng-deep
  .filter-row
  .mat-form-field-appearance-outline
  .mat-form-field-outline {
  color: #e0e0e0 !important;
}

:host
  ::ng-deep
  .filter-row
  .mat-form-field-appearance-outline:hover
  .mat-form-field-outline-thick,
:host
  ::ng-deep
  .filter-row
  .mat-form-field-appearance-outline.mat-focused
  .mat-form-field-outline-thick {
  color: #b0b0b0 !important;
}

.status-label.policy-issued {
  background-color: #e6f7ed;
  color: #1a7f37;
}

.status-label {
  padding: 4px 25px;
  border-radius: 24px;
}

:host ::ng-deep .mat-cell {
  color: #616161;
  font-weight: 400;
  font-size: 12px;
}

:host ::ng-deep .mat-header-cell {
  color: #1c1c1c;
  font-weight: 600;
  font-size: 12px;
}

:host ::ng-deep .mat-form-field-flex {
  margin-top: 0px !important;
  padding-top: 2px !important;
  height: 40px !important;
}

:host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {
  padding: 0 !important;
}

:host ::ng-deep .mat-input-element {
  font-size: 16px !important;
  font-weight: 400;
}

.filter-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

:host ::ng-deep * {
  font-family: "Roboto", sans-serif !important;
}

h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #1c1c1c;
  font-family: "Roboto", sans-serif !important;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/careplus/careplus-policy/careplus-policy.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uEAAuE;EACvE,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA,ooNAAooN","sourcesContent":["table {\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\nth.mat-header-cell,\ntd.mat-cell {\n  padding: 0 16px !important;\n  white-space: nowrap;\n}\n\ntr.mat-row:hover {\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n\ntr.mat-row {\n  height: 52px;\n}\n\ntr.mat-header-row {\n  height: 52px;\n  background-color: #fafafa;\n}\n\n.deactivated-row td {\n  color: #aaa !important;\n  background-color: #f5f5f5 !important;\n  opacity: 0.7;\n}\n\n.deactivated-row:hover td {\n  background-color: #eeeeee !important;\n}\n\n.selection-bar {\n  display: flex;\n  align-items: center;\n  background-color: #f5f5f5;\n  padding: 0 16px;\n  border-radius: 8px;\n  margin: 10px 0;\n  width: 100%;\n  min-height: 48px;\n}\n\n.selection-info {\n  display: flex;\n  align-items: center;\n}\n\n.vertical-divider {\n  width: 1px;\n  height: 24px;\n  background-color: #dbdbdb;\n  margin: 0 12px;\n}\n\n.selection-count {\n  font-weight: 500;\n  color: #1c1c1c;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.filter-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.filter-row mat-form-field {\n  width: 250px;\n}\n\n.btn {\n  background: linear-gradient(90deg, #00b2ff 0%, #1288ff 100%) !important;\n  color: white !important;\n  border-radius: 24px !important;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.ml-auto {\n  margin-left: auto !important;\n}\n\n.download-btn {\n  background-color: transparent !important;\n  color: #1288ff !important;\n  border: 1px solid #1288ff !important;\n  border-radius: 24px !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  cursor: pointer;\n}\n\n.white-spinner ::ng-deep circle {\n  stroke: #999999 !important;\n}\n\n.filter-row mat-form-field {\n  width: 250px;\n}\n\n:host ::ng-deep .filter-row .mat-form-field-wrapper {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n:host ::ng-deep .filter-row .mat-form-field-subscript-wrapper {\n  display: none !important;\n}\n\n:host ::ng-deep .filter-row .mat-form-field-infix {\n  padding: 8px 0 !important;\n  border-top: 0 !important;\n  width: auto !important;\n}\n\n:host\n  ::ng-deep\n  .filter-row\n  .mat-form-field-appearance-outline\n  .mat-form-field-outline {\n  color: #e0e0e0 !important;\n}\n\n:host\n  ::ng-deep\n  .filter-row\n  .mat-form-field-appearance-outline:hover\n  .mat-form-field-outline-thick,\n:host\n  ::ng-deep\n  .filter-row\n  .mat-form-field-appearance-outline.mat-focused\n  .mat-form-field-outline-thick {\n  color: #b0b0b0 !important;\n}\n\n.status-label.policy-issued {\n  background-color: #e6f7ed;\n  color: #1a7f37;\n}\n\n.status-label {\n  padding: 4px 25px;\n  border-radius: 24px;\n}\n\n:host ::ng-deep .mat-cell {\n  color: #616161;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n:host ::ng-deep .mat-header-cell {\n  color: #1c1c1c;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n:host ::ng-deep .mat-form-field-flex {\n  margin-top: 0px !important;\n  padding-top: 2px !important;\n  height: 40px !important;\n}\n\n:host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {\n  padding: 0 !important;\n}\n\n:host ::ng-deep .mat-input-element {\n  font-size: 16px !important;\n  font-weight: 400;\n}\n\n.filter-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n:host ::ng-deep * {\n  font-family: \"Roboto\", sans-serif !important;\n}\n\nh2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #1c1c1c;\n  font-family: \"Roboto\", sans-serif !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
